import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 17v-4l-5 3l-5 -3v4l5 3z","key":"svg-0"}],["path",{"d":"M17 8v-4l-5 3l-5 -3v4l5 3z","key":"svg-1"}]]

const IconBadges = createReactComponent('outline', 'badges', 'Badges', __iconNode);

export default IconBadges;